var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:{ 'text-danger': _vm.time < 60 }},[_vm._v("\n    "+_vm._s(_vm.timeHuman)+"\n")])}
var staticRenderFns = []

export { render, staticRenderFns }